module.exports = __webpack_public_path__ + "static/media/Ersa Mantashi.0a40b27d.png";